import React from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
const { confirm } = Modal;

const DialogConfirm = (config, title = "Мэдээллийг устгах уу?") => {
  confirm({
    title: title,
    icon: <ExclamationCircleOutlined />,
    content: "",
    okText: "Тийм",
    okType: "warning",
    cancelText: "Цуцлах",
    onOk() {},
    onCancel() {},
    ...config,
  });
};

export default DialogConfirm;
